import { Router } from 'express';
import { db } from '../storage';
import { Student } from '../../src/types';

export const studentsRouter = Router();

// Get students for teacher
studentsRouter.get('/', (req, res) => {
  const teacherId = req.query.teacherId as string;
  const classId = req.query.classId as string;
  if (!teacherId) return res.status(400).json({ error: 'Missing teacherId' });

  const list = db.getStudents(teacherId, classId);
  res.json(list);
});

// Create student
studentsRouter.post('/', (req, res) => {
  const {
    teacherId,
    classId,
    name,
    code,
    phone,
    parentName,
    parentPhone,
    parentZalo,
    feeStatus,
    tuitionFeeDue,
    tuitionFeePaid,
    notes
  } = req.body;

  if (!teacherId || !classId || !name) {
    return res.status(400).json({ error: 'Thiếu thông tin bắt buộc (Giáo viên, Lớp học, Tên học sinh)' });
  }

  const newStudent: Student = {
    id: `std_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`,
    teacherId,
    classId,
    name,
    code: code || `HS-${Math.floor(1000 + Math.random() * 9000)}`,
    phone: phone || '',
    parentName: parentName || '',
    parentPhone: parentPhone || '',
    parentZalo: parentZalo || parentPhone || '',
    feeStatus: feeStatus || 'unpaid',
    tuitionFeeDue: Number(tuitionFeeDue) || 1200000,
    tuitionFeePaid: Number(tuitionFeePaid) || 0,
    joinedDate: new Date().toISOString().substring(0, 10),
    notes: notes || '',
    active: true
  };

  db.createStudent(newStudent);
  res.json(newStudent);
});

// Update student
studentsRouter.put('/:id', (req, res) => {
  const { id } = req.params;
  const { teacherId, ...updates } = req.body;
  if (!teacherId) return res.status(400).json({ error: 'Missing teacherId' });

  const updated = db.updateStudent(teacherId, id, updates);
  if (!updated) return res.status(404).json({ error: 'Không tìm thấy học sinh' });
  res.json(updated);
});

// Delete student
studentsRouter.delete('/:id', (req, res) => {
  const { id } = req.params;
  const teacherId = req.query.teacherId as string;
  if (!teacherId) return res.status(400).json({ error: 'Missing teacherId' });

  const success = db.deleteStudent(teacherId, id);
  res.json({ success });
});
